import { useTranslation } from 'react-i18next'

import { Button } from '@percent/lemonade'
import { downloadJsonFile } from '@percent/partner-dashboard/common/library/utility/utility'
import type { UseAiChatResult } from '@percent/domain/ai-chat'

export const INSIGHTS_AI_DEBUG_EXPORT_OBJECT = 'insights_ai_debug_export'

/** Downloads every turn's question and raw backend events as JSON, for manually
 * validating what the agent returned - including the events the UI never shows. */
export function InsightsAiDebugExport({ chat }: Readonly<{ chat: UseAiChatResult }>) {
  const { t } = useTranslation()

  const exportTrace = () => {
    const exportedAt = new Date().toISOString()

    downloadJsonFile(
      { object: INSIGHTS_AI_DEBUG_EXPORT_OBJECT, exportedAt, turns: chat.getDebugTrace() },
      // Colons and dots aren't safe in filenames across every OS.
      `insights-ai-debug-${exportedAt.replace(/[:.]/g, '-')}`
    )
  }

  return (
    <Button
      variant="secondary"
      size="small"
      startIcon="download"
      onClick={exportTrace}
      disabled={chat.getDebugTrace().length === 0}
      data-testid="insights-ai-debug-export"
    >
      {t('button.exportInsightsAiDebug')}
    </Button>
  )
}
